import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Row = ({ label, v, id, fmt }) => (
  <div className="flex justify-between gap-4 text-xs" data-testid={id}>
    <span className="text-muted-foreground">{label}</span><span className="font-mono">{fmt(v)}</span>
  </div>
);

const PreviewBreakdown = ({ data, fmt }) => {
  const r = data.purchase_reconciliation, s = data.summary || {};
  return (
    <div className="grid sm:grid-cols-2 gap-x-8 gap-y-1">
      <Row fmt={fmt} label="All expense records" v={s.all_expenses_total} id="pc-all" />
      <Row fmt={fmt} label="Excluded (not purchases)" v={r.excluded_non_purchase.amount} id="pc-excluded" />
      <Row fmt={fmt} label="Classified purchases (boxes 7, 10, 11)" v={s.input_total_purchases} id="pc-classified" />
      <Row fmt={fmt} label="Out of scope — no VAT" v={r.out_of_scope_no_vat.amount} id="pc-no-vat" />
      <Row fmt={fmt} label="Pending classification" v={r.unclassified.amount} id="pc-unclassified" />
    </div>
  );
};

export const PurchaseClassificationBanner = ({ data, fmt }) => {
  const preview = data?.purchase_reconciliation;
  const live = data?.purchase_classification;
  if (!preview && !live) return null;
  const pending = preview ? preview.unclassified : live.unclassified;
  const noVat = preview ? preview.out_of_scope_no_vat : live.no_vat;
  const incomplete = pending.count > 0;
  return (
    <div data-testid="purchase-classification-banner"
      className={`rounded-lg border p-4 ${incomplete ? 'border-warning/40 bg-warning/10' : 'border-success/30 bg-success/10'}`}>
      <div className="flex items-start gap-2">
        <AlertTriangle className={`w-4 h-4 mt-0.5 ${incomplete ? 'text-warning' : 'text-success'}`} />
        <div className="flex-1 space-y-2">
          <p className="text-sm font-semibold" data-testid="purchase-classification-status">
            {incomplete ? `Not ready for filing — classification incomplete: ${pending.count} purchases (${fmt(pending.amount)}) awaiting VAT classification` : 'All purchases classified'}
          </p>
          {incomplete && (
            <p className="text-xs text-muted-foreground" data-testid="purchase-classification-note">
              Purchase VAT boxes are not final until these purchases are classified from supplier invoices and reconciled. No input VAT is claimed without evidence.
              {noVat.count > 0 && ` ${noVat.count} purchases (${fmt(noVat.amount)}) are marked No VAT and remain open for verification.`}
            </p>
          )}
          {preview && <PreviewBreakdown data={data} fmt={fmt} />}
          {incomplete && (
            <Link to="/expenses?vat_review=1" data-testid="purchase-classification-review-link"
              className="inline-flex items-center gap-1 text-xs font-medium text-info hover:underline">
              Open purchase VAT review <ExternalLink size={12} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
